export interface AdvanceMode {
  key: string;
  label: string;
  caption: string;
}

const HELPER_TEXT =
  "Consolidated pools the advance across the party's whole share. Segregated tracks a separate advance per territory / sale type row.";

export const ADVANCE_MODES: AdvanceMode[] = [
  { key: 'Consolidated', label: 'Consolidated (per party)', caption: HELPER_TEXT },
  { key: 'Segregated', label: 'Segregated', caption: HELPER_TEXT },
];

/** Contracts saved before this change may still carry the legacy 'Per Party' value. */
const LEGACY_ALIASES: Record<string, string> = {
  'Per Party': 'Consolidated',
};

export function findAdvanceMode(key: string | null | undefined): AdvanceMode | undefined {
  if (key === null || key === undefined) {
    return undefined;
  }
  const resolvedKey = LEGACY_ALIASES[key] ?? key;
  return ADVANCE_MODES.find((mode) => mode.key === resolvedKey);
}
